import React, { useState, useRef, useEffect } from "react"
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from "react-router-dom";

import { getFlags } from '../../routes/UserAction';

import { domain, reduceText } from '../../data/dummyData';


const Footer = (props) => {
    const dispatch = useDispatch();
    const {
        loading,
        user,
        error,
        success,
        successMessage,
    } = useSelector((state) => state.user || {});
    const userData = user;

    const [flags, setFlags] = useState([]);
    const fetchFlags = () => {
        dispatch(getFlags())
        .then(response =>{
            let resData = response?.payload?.data;
            const editableData = resData?.map(o => ({ ...o }));
            setFlags(editableData);
        })
        .catch((error) => {
            console.log(error)
        })
    }

    useEffect(() => {
        fetchFlags();
    }, [])
    

    

    return (
        // loading ? (
        //     <div className="loader-container">
        //         <div className="spinner"></div>
        //         {/* <h6 style={{color: 'white', textAlign:'center'}}>loading please wait...</h6> */}
        //     </div>
        // ) :
        // <>
            // <TermsModal 
            //     title={'Terms of service'}
            //     // tableForm={<Guide 
            //     // ref={guideRef} 
            //     // />} 
            //     ref={modalRef}
            //     // handleSubmit={''}
                
            // />


            // <!-- Footer Start -->
            <div className="container-fluid footer py-5 wow fadeIn" data-wow-delay="0.2s">
                <div className="container py-5">
                    <div className="row g-5 mb-5 align-items-center">
                        <div className="col-lg-7">
                            <div className="position-relative d-flex" style={{transform: 'skew(18deg)'}}>
                                <input className="form-control border-0 w-100 py-3 pe-5" type="text" placeholder="Email address to Subscribe"/>
                                <button type="button" className="btn-primary py-2 px-4 ms-3"> <span>Subscribe</span></button>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="d-flex align-items-center justify-content-center justify-content-lg-end">
                            <a
                                className="btn btn-primary btn-md-square me-3"
                                href={flags?.find(el => el.name === 'emy_facebook' && el.type === 1)?.value || '#'}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fab fa-facebook-f"></i>
                            </a>

                            <a
                                className="btn btn-primary btn-md-square me-3"
                                href={flags?.find(el => el.name === 'emy_x' && el.type === 1)?.value || '#'}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="">X</i>
                                {/* <i className="fab fa-twitter"></i> */}
                            </a>

                            <a
                                className="btn btn-primary btn-md-square me-3"
                                href={flags?.find(el => el.name === 'emy_tiktok' && el.type === 1)?.value || '#'}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fab fa-tiktok"></i> {/* You can change this to a TikTok icon if added */}
                            </a>

                            <a
                                className="btn btn-primary btn-md-square me-0"
                                href={`mailto:${flags?.find(el => el.name === 'emy_email' && el.type === 1)?.value || 'info@mj-emylab.com'}`}
                            >
                                <i className="fas fa-envelope"></i>
                            </a>
                            </div>
                        </div>
                    </div>
                    <div className="row g-5">
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="footer-item">
                                {/* <Link to={'/'}><h4 className="text-white mb-4">
                                    <img className="mb-1" style={{width: 40, height: 50}} src="./assets/img/emy.png" alt="Logo"/> MJ-EMYLAB
                                </h4></Link> */}

                                <Link to={'/'}>
                                    <img className="mb-1" style={{width: 200, height: 250}} src={props.subpage? "../assets/img/emy.png":"./assets/img/emy.png"} alt="Logo"/>
                                </Link>

                                {/* <p className="mb-0 text-white">Dolor amet sit justo amet elitr clita ipsum elitr est.Lorem ipsum dolor sit amet, consectetur adipiscing elit consectetur adipiscing elit.</p> */}
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="footer-item">
                                <h4 className="text-white mb-4">Quick Links</h4>
                                <Link to={'/'}> Home</Link>
                                <Link to={'/about'}> About us</Link>
                                <Link to={'/countries'}> Countries</Link>
                                <Link to={'/departments'}> Departments</Link>
                                <Link to={'/blogs'}> Our Blog & news</Link>
                                <Link to={'/emy_form'}> EmyForm</Link>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="footer-item">
                                <h4 className="text-white mb-4"> Contact Info</h4>
                                <div className="row g-2">
                                    <div className="col-12">
                                        <div className="d-flex">
                                            <i className="fas fa-map-marker-alt text-primary me-2"></i>
                                            <div>
                                                <h5 className="text-white mb-2">Head Office</h5>
                                                <p className="mb-0 text-white">Accra, Ghana</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="d-flex">
                                            <i className="fas fa-envelope text-primary me-2"></i>
                                            <div>
                                                <h5 className="text-white mb-2">Mail Us</h5>
                                                <p className="mb-0 text-white">info@mj-emylab.com</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="d-flex">
                                            <i className="fa fa-phone-alt text-primary me-2"></i>
                                            <div>
                                                <h5 className="text-white mb-2">Telephone</h5>
                                                <p className="mb-0 text-white">(+233) 559 148 214</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="footer-item">
                                {/* <h4 className="text-white mb-4">Recent Work</h4> */}
                                {/* <div className="row g-2">
                                    <div className="col-3">
                                        <div className="footer-item-img">
                                            <Link to={'/'}><img src="./assets/img/soft.png" className="img-fluid" alt=""/></Link>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="footer-item-img">
                                            <Link to={'/'}><img src="./assets/img/soft.png" className="img-fluid" alt=""/></Link>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="footer-item-img">
                                            <Link to={'/'}><img src="./assets/img/soft.png" className="img-fluid" alt=""/></Link>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="footer-item-img">
                                            <Link to={'/'}><img src="./assets/img/soft.png" className="img-fluid" alt=""/></Link>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="footer-item-img">
                                            <Link to={'/'}><img src="./assets/img/soft.png" className="img-fluid" alt=""/></Link>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="footer-item-img">
                                            <Link to={'/'}><img src="./assets/img/soft.png" className="img-fluid" alt=""/></Link>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="footer-item-img">
                                            <Link to={'/'}><img src="./assets/img/soft.png" className="img-fluid" alt=""/></Link>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="footer-item-img">
                                            <Link to={'/'}><img src="./assets/img/soft.png" className="img-fluid" alt=""/></Link>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="footer-item-img">
                                            <Link to={'/'}><img src="./assets/img/soft.png" className="img-fluid" alt=""/></Link>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="footer-item-img">
                                            <Link to={'/'}><img src="./assets/img/soft.png" className="img-fluid" alt=""/></Link>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="footer-item-img">
                                            <Link to={'/'}><img src="./assets/img/soft.png" className="img-fluid" alt=""/></Link>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <div className="footer-item-img">
                                            <Link to={'/'}><img src="./assets/img/soft.png" className="img-fluid" alt=""/></Link>
                                        </div>
                                    </div>
                                </div> */}

                                <Link to={'/'}>
                                    <img className="mb-1" style={{width: 200, height: 250}} src={props.subpage? "../assets/img/soft.png":"./assets/img/soft.png"} alt="Logo"/>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

    //     </>
    )
}

export default Footer